// extracted by mini-css-extract-plugin
export default {"header-container":"CouponPreset_header-container__m+-Jo","flex":"CouponPreset_flex__X9IIC","order-btn":"CouponPreset_order-btn__gXniR","table":"CouponPreset_table__J4UTO"};